import { Validable, isImplementValidable } from '../components/inputs/Validable';

export class PageValidate {
  public static validate(refs: any): boolean {
    let hasError = false;
    for (const refName in refs) {
      const ref = refs[refName];
      console.log(refName);
      if (!isImplementValidable(ref)) {
        continue;
      }
      const validable: Validable = ref as Validable;
      const result = validable.validation();
      hasError = hasError || result.hasErrors;
    }
    return hasError;
  }
}
